// extracted by mini-css-extract-plugin
export var countdownWrapper = "countdown-module--countdown-wrapper--f0546";
export var countdownWrapper__timeSegment = "countdown-module--countdown-wrapper__time-segment--f7af7";